import React, { useState, useEffect } from 'react';
import { IoMdRocket } from "react-icons/io";

const ScrollToTop = ({ isFooterVisible }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className={`scroll-to-top ${isFooterVisible ? 'footer-visible' : ''}`}>
      {isVisible && (
        <div onClick={scrollToTop} className="scroll-button">
          <IoMdRocket />
        </div>
      )}
    </div>
  );
};

export default ScrollToTop;
